module.exports = __webpack_public_path__ + "static/media/circle-white.2f13bdac.svg";